import { vehiclesApi } from '@/lib/api';
import {
  locationMatchesListedCity,
  slugFromCityLabel,
} from '@/lib/seo/city-inventory-match';
import type { Vehicle } from '@/types/vehicle';

/** Ex. `?city=Casablanca` → `Casablanca` (même filtre que `PopularCars`). */
export const parseCityFromIntentCta = (ctaSearchParams: string): string | undefined => {
  const raw = ctaSearchParams.trim();
  if (!raw) {
    return undefined;
  }
  const qs = raw.startsWith('?') ? raw.slice(1) : raw;
  const city = new URLSearchParams(qs).get('city');
  const trimmed = city?.trim();
  return trimmed || undefined;
};

/** Aligné sur `PopularCars` : mêmes données, même clé de cache React Query. */
export const popularVehiclesQueryKey = (location?: string) =>
  ['popular-vehicles', location ?? ''] as const;

export const fetchPopularVehiclesForLocation = async (
  location?: string
): Promise<Vehicle[]> => {
  try {
    const allVehicles = await vehiclesApi.getVehicles();
    const list = Array.isArray(allVehicles) ? allVehicles : [];
    if (!location?.trim()) {
      return list;
    }
    if (slugFromCityLabel(location)) {
      return list.filter(
        (vehicle) =>
          typeof vehicle?.location === 'string' &&
          locationMatchesListedCity(vehicle.location, location)
      );
    }
    const needle = location.trim().toLowerCase();
    return list.filter(
      (vehicle) =>
        typeof vehicle?.location === "string" &&
        vehicle.location.toLowerCase().includes(needle)
    );
  } catch (error) {
    console.error("[popular-vehicles] Unable to load the city feed:", error);
    return [];
  }
};

/** Aligné sur le filtre recherche « sans caution » (annonces actives vérifiées). */
export const noDepositListingsQueryKey = () => ['vehicles', 'no-deposit-listings'] as const;

export const fetchNoDepositListingCount = async (): Promise<number> => {
  const list = await vehiclesApi.searchVehicles({ noDeposit: true });
  return list.length;
};
